import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { useResizeDetector } from "react-resize-detector";

import '../App.css';
import { Container,Col,Row } from  "react-bootstrap";
import eventhead from '../Images/eventhead.webp';
import eventmobile from '../Images/eventmobile.webp';
import line from '../Images/line.png';

export default function Gallery() {
    const imgCDNURL = process.env.REACT_APP_SUNWESTEXPO_CDN_URL;
    const { width, ref } = useResizeDetector();
    
    let device;
    if (width < 768) {
        device = "mobile";
    } else if (width < 992) {
        device = "tablet";
    } else if (width < 2001) {
        device = "desktop";
    } else {
        device = "superLargeDesktop";
    }

    const responsive = {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 2001 },
          items: 1,
        },
        desktop: {
          breakpoint: { max: 2000, min: 992 },
          items: 1,
        },
        tablet: {
          breakpoint: { max: 991, min: 768 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 767, min: 0 },
          items: 1,
        },
    };

        return (
            <div className="eventbg">
                <>
            <Container>
                <Row>
            
            
             <Col lg={12} className="videoslide">    
              <img src= {eventhead} alt="event-heading" className="event"/> 
              <img src= {eventmobile} alt="event-heading" className="eventmobile"/> 
              
              <p className="text-center memory">Event Memories</p>
     
               <Carousel autoPlay interval="5000" 
               transitionTime="3000" 
               infiniteLoop 
               responsive={responsive}
                showIndicators={false}
                minimumTouchDrag={80}
                slidesToSlide={1}
                partialVisibile={true}
                showArrows={false}
                
                dynamicHeight
                className="text-center"
                
                //breakpoint="320"
                       
                >
                    <div>
                    <img src={imgCDNURL + "1.webp"} className="image1 img-fluid" alt="image1" />
                        
                    </div>
                    <div>
                    <img src={imgCDNURL + "2.webp"} className="image1 img-fluid" alt="image1" />
                        
                    </div>
                    <div>
                    <img src={imgCDNURL + "3.webp"} className="image1 img-fluid" alt="image1" />
                        
                    </div>
                    <div>
                    <img src={imgCDNURL + "4.webp"} className="image1 img-fluid" alt="image1" />
                        
                    </div>
                    <div>
                    <img src={imgCDNURL + "5.webp"} className="image1 img-fluid" alt="image1" />
                        
                    </div>
                    <div>
                    <img src={imgCDNURL + "6.webp"} className="image1 img-fluid" alt="image1" />
                        
                    </div>
                    </Carousel>
                    </Col>
                    <Col lg={12} md={12} xl={12} className="pb-3">
                        <p className="expo"> If you have additional memories you want us to share on this site, all you need to do is post it on social media with 
                        <b> #sunwestexpo </b> and we will automatically pick it up and put it on the site.</p>

                    </Col>
                </Row>
            </Container>
            </>
            </div>
          
        );

}
